<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="BCMForm" autocomplete="off">
        <ng-container formArrayName="BCMRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="5">
                <div class="pull-left">
                  <h4>BOM Codes</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add new BOM Code" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- Bom Code Column -->
            <ng-container matColumnDef="bomcode">
              <th mat-header-cell *matHeaderCellDef style="width:20%">BOM Code</th>
              <td mat-cell *matCellDef="let element; let i = index" style="width:20%">
                @if (BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                  <div [innerHTML]="BCMForm.get('BCMRows')?.value[i].bomCode"></div>
                }
                @if (!BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                  <mat-form-field style="width: 100%">
                    <input matInput type="text"
                      [ngModelOptions]="{standalone: true}"
                      [ngModel]="BCMForm.get('BCMRows')?.value[i].bomCode"
                      (ngModelChange)="BCMForm.get('BCMRows')!.value[i].bomCode = $event"
                      maxlength="128"
                      matTooltip="Max 128 characters"/>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Family Code Column -->
              <ng-container matColumnDef="familycode">
                <th mat-header-cell *matHeaderCellDef style="width:20%">Family Code</th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:20%">
                  @if (BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <div [innerHTML]="getFamilyCodeName(BCMForm.get('BCMRows')?.value[i].familyCodeId)"></div>
                  }
                  @if (!BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <mat-select style="min-width: 200px; color:red"
                        [ngModel]="BCMForm.get('BCMRows')?.value[i].familyCodeId"
                        (ngModelChange)="BCMForm.get('BCMRows')!.value[i].familyCodeId = $event"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (fc of availableFamilyCodes; track fc) {
                          <mat-option [value]="fc.familyCodeId">
                            {{ fc.familyCodeName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Center Column -->
              <ng-container matColumnDef="center">
                <th mat-header-cell *matHeaderCellDef style="width:15%">Center</th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:15%">
                  @if (BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <div [innerHTML]="getCenterName(BCMForm.get('BCMRows')?.value[i].mfgCenterId)"></div>
                  }
                  @if (!BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <mat-form-field floatLabel="auto">
                      <mat-select style="min-width: 200px; color:red"
                        [ngModel]="BCMForm.get('BCMRows')?.value[i].mfgCenterId"
                        (ngModelChange)="BCMForm.get('BCMRows')!.value[i].mfgCenterId = $event"
                        [ngModelOptions]="{standalone: true}">
                        <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                        @for (center of availableCenters; track center) {
                          <mat-option [value]="center.centerId">
                            {{ center.centerName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef style="width:20%">UTC modification date</th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:20%">
                  {{datePipe.transform(BCMForm.get('BCMRows')?.value[i]?.utcModifDate,'yyyy-MM-dd HH:mm')}}
                </td>
              </ng-container>

              <!-- User Column -->
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef style="width:20%">Modified by</th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:20%">
                  {{BCMForm.get('BCMRows')?.value[i]?.modifUser}}
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef style="width:5%"></th>
                <td mat-cell
                  *matCellDef="let element; let i = index" style="width:5%">

                  @if (!BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <button mat-icon-button
                      matTooltip="Cancel Changes"
                      color="warn"
                      (click)="resetRow(i)">
                      <mat-icon class="actionButtons">rotate_left</mat-icon>
                    </button>
                  }

                  @if (BCMForm.get('BCMRows')?.value[i]?.isEditable) {
                    <button mat-icon-button
                      matTooltip="Edit"
                      color="primary"
                      (click)="editRow(BCMForm, i)">
                      <mat-icon class="actionButtons">edit</mat-icon>
                    </button>
                  }

                  @if (false) {
                    <button mat-icon-button
                      matTooltip="Delete"
                      color="warn"
                      (click)="deleteRow(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="savefooter">
                <th mat-footer-cell *matFooterCellDef colspan="6">
                  <div class="OrangeButton">
                    <button mat-raised-button type="submit" (click)="onSave()"
                      [disabled]="!anyChange()"
                      [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                      class="button-color-fix pull-right">
                      Save
                      <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                    </button>
                  </div>
                </th>

              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
              <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay;" [class.alternative2]="!BCMForm.get('BCMRows')?.value[i]?.isEditable"></tr>
              <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
            </table>
          </ng-container>
        </form>
      </div>
    </div>
  </div>
